import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";
axios.defaults.baseURL = API_URL;
// Configurer le token d'authentification pour toutes les requêtes
const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    localStorage.setItem("token", token);
  } else {
    delete axios.defaults.headers.common["Authorization"];
    localStorage.removeItem("token");
  }
};

// Vérifier si l'utilisateur est authentifié
const isAuthenticated = () => {
  return localStorage.getItem("token") !== null;
};

// Récupérer les informations de l'utilisateur connecté
const getCurrentUser = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;

    setAuthToken(token);
    const res = await axios.get("/api/auth/me");
    return res.data.user;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des informations utilisateur:",
      error
    );
    // Si erreur 401, supprimer le token
    if (error.response && error.response.status === 401) {
      setAuthToken(null);
    }
    return null;
  }
};

// Connexion
const login = async (username, password) => {
  try {
    const res = await axios.post("/api/auth/login", { username, password });

    if (res.data.success) {
      setAuthToken(res.data.token);
      return res.data.user;
    }

    return null;
  } catch ($) {
    throw "Erreur lors de la connexion";
  }
};

// Déconnexion
const logout = () => {
  setAuthToken(null);
};

// Enregistrer les identifiants Xandr
const saveXandrCredentials = async (xandrUsername, xandrPassword) => {
  try {
    const response = await axios.post('/api/auth/xandr-credentials', {
      xandrUsername,
      xandrPassword
    });
    
    // Si la sauvegarde réussit, mettre à jour les informations utilisateur
    if (response.data.success) {
      // Optionnel: mettre à jour les informations utilisateur en mémoire
      return response.data;
    }
    
    throw new Error(response.data.message || 'Erreur lors de l\'enregistrement des identifiants');
  } catch (error) {
    console.error('Erreur lors de l\'enregistrement des identifiants Xandr:', error);
    throw error;
  }
};

const authService = {
  setAuthToken,
  isAuthenticated,
  getCurrentUser,
  login,
  logout,
  saveXandrCredentials,
};

export default authService;
